import axios from "axios";

export default function createBranchGroup(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/account/api/v1/branch-group/add`, {
        name: parameters.name,
        role_uuid: parameters.role_uuid,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
